define(function(require, exports, module) {
    'use strict';

    module.exports = {
        notify: function(options) {
            window.Playtech.API.popup.showPopup('twoFactorAuthentication', options?.data || {});
        }
    };
});
